import { render, staticRenderFns } from "./CustomCalendar.vue?vue&type=template&id=0fa92056&scoped=true&"
import script from "./CustomCalendar.vue?vue&type=script&lang=js&"
export * from "./CustomCalendar.vue?vue&type=script&lang=js&"
import style0 from "./CustomCalendar.vue?vue&type=style&index=0&id=0fa92056&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa92056",
  null
  
)

export default component.exports